import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=4ed4b2dc&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=4ed4b2dc&scoped=true&lang=css&"
import style1 from "./Statistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4b2dc",
  null
  
)

component.options.__file = "Statistics.vue"
export default component.exports